import { render, staticRenderFns } from "./QuestionSubSectionPrint.vue?vue&type=template&id=ef0e1c70&scoped=true"
import script from "./QuestionSubSectionPrint.vue?vue&type=script&lang=js"
export * from "./QuestionSubSectionPrint.vue?vue&type=script&lang=js"
import style0 from "./QuestionSubSectionPrint.vue?vue&type=style&index=0&id=ef0e1c70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0e1c70",
  null
  
)

export default component.exports